import { render, staticRenderFns } from "./TeamSelfAwareness.vue?vue&type=template&id=3c1aabc8&scoped=true&"
import script from "./TeamSelfAwareness.vue?vue&type=script&lang=js&"
export * from "./TeamSelfAwareness.vue?vue&type=script&lang=js&"
import style0 from "./TeamSelfAwareness.vue?vue&type=style&index=0&id=3c1aabc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1aabc8",
  null
  
)

export default component.exports